import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  Signal,
  effect
} from "@angular/core";
import { FormService } from "src/app/services/form.service";
import { IconService } from "src/app/services/icon.service";
import {
  WorkshopSystemEnum,
  ActiveWorkshopSystemResponse
} from "src/domain/client";
import { PageBaseComponent } from "../../base/page-base/page-base.component";
import { PageContainerComponent } from "../../layout/page-container/page-container.component";
import { LoadingComponent } from "../../layout/loading/loading.component";
import { RequestFailedComponent } from "../../layout/request-failed/request-failed.component";
import { CheckboxCardComponent } from "../../layout/checkbox-card/checkbox-card.component";
import { TranslateModule } from "@ngx-translate/core";

import * as BookingState from "src/app/state";
import { Store } from "@ngrx/store";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-workshop-system-selection",
  templateUrl: "./workshop-system-selection.component.html",
  imports: [
    PageContainerComponent,
    LoadingComponent,
    RequestFailedComponent,
    CheckboxCardComponent,
    TranslateModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkshopSystemSelectionComponent
  extends PageBaseComponent
  implements OnInit, OnDestroy
{
  readonly systems: Signal<ActiveWorkshopSystemResponse[] | null>;
  readonly isLoading: Signal<boolean>;
  readonly error: Signal<BookingState.AppError | null>;
  readonly selectedSystems: Signal<WorkshopSystemEnum[] | null>;

  constructor(
    public formService: FormService,
    public iconService: IconService,
    private store: Store
  ) {
    super();

    this.systems = this.store.selectSignal(
      BookingState.selectSortedActiveWorkshopSystems
    );
    this.selectedSystems = this.store.selectSignal(
      BookingState.selectSelectedWorkshopSystems
    );
    this.isLoading = this.store.selectSignal(BookingState.selectIsLoading);
    this.error = this.store.selectSignal(BookingState.selectError);

    this.formService.workshopSystemSelectionForm.markAsPristine();
    this.formService.previousFormValue =
      this.formService.workshopSystemSelectionForm.value;

    const formChanges = toSignal(
      this.formService.workshopSystemSelectionForm.valueChanges
    );

    effect(() => {
      formChanges();
      const selected = this.formService.serviceTypeSelection;
      this.store.dispatch(
        BookingState.submitWorkshopSystems({ selectedSystems: selected })
      );
    });

    effect(() => {
      const previouslySelected = this.selectedSystems();
      const form = this.formService.workshopSystemSelectionForm;

      if (previouslySelected) {
        const formValue: { [key: string]: boolean } = {};
        Object.keys(form.controls).forEach((key) => {
          formValue[key] = previouslySelected.includes(
            key as WorkshopSystemEnum
          );
        });

        form.patchValue(formValue, { emitEvent: false });
        form.updateValueAndValidity({ emitEvent: false });
      }
    });
  }
  ngOnDestroy(): void {
    this.cleanUp();
  }

  ngOnInit(): void {
    if (this.systems() === null) {
      this.store.dispatch(BookingState.loadActiveWorkshopSystems());
    }
  }
}
